import { Outlet } from 'react-router-dom';

import { RequireAuth } from '@sorare/core/src/routing/RequireAuth';

const OnboardingLayout = () => {
  return (
    <RequireAuth>
      <Outlet />
    </RequireAuth>
  );
};
export default OnboardingLayout;
